import angular from 'angular';

angular
  .module('cxTranslations')
  .controller('TranslateListsCtrl', [
    '$filter',
    'translateSvc',
    'localStorageService',
    TranslateListsCtrl,
  ]);

function formatSource(source) {
  if (!source) return '';
  const parts = source
    .split(',')
    .map(x => x.trim())
    .unique();
  return parts.join(', ');
}

function TranslateListsCtrl($filter, translateSvc, localStorageService) {
  var vm = this;
  //Filters
  vm.fNotTranslated = true;
  vm.fSimilar = false;
  vm.fInherited = false;
  vm.fListName = null;
  //Data
  vm.loading = false;
  vm.languages = [];
  vm.allLanguages = [];
  vm.translations = [];
  vm.allTranslations = [];
  vm.listNames = [];
  vm.selectedLanguages = localStorageService.get('TranslationToolLanguages') || ['nl'];

  //Visibility Toggles
  vm.showModifiedDates = false;
  vm.showScanInfo = false;
  vm.showKey = false;

  //Language functions

  //Add a language column to the table
  vm.addLanguage = function(lang) {
    if (!lang) return;
    vm.selectedLanguages.push(lang);
    localStorageService.set('TranslationToolLanguages', vm.selectedLanguages);
    vm.filterLanguages();
    vm.getTranslations([lang]);
  };
  //Remove a language column
  vm.removeLanguage = function(lang) {
    if (!lang) return;
    var idx = vm.selectedLanguages.indexOf(lang);
    if (idx >= 0) {
      vm.selectedLanguages.splice(idx, 1);
      vm.filterLanguages();
      localStorageService.set('TranslationToolLanguages', vm.selectedLanguages);
    }
  };

  vm.filterLanguages = function() {
    vm.languages = vm.allLanguages.filter(function(lang) {
      return vm.selectedLanguages.indexOf(lang) < 0;
    });
  };

  //Translation functions
  vm.getTranslations = function(languages) {
    if (!languages || !languages.length) return;
    vm.loading = true;
    return translateSvc.getLists(vm.selectedLanguages).then(function(data) {
      if (vm.allTranslations.length) {
        //When adding language
        for (var i = 0; i < data.length; i++) {
          var group = data[i];
          var translation = vm.allTranslations.find(function(x) {
            return x.key === group.key;
          });
          if (!translation) {
            translation = {
              key: group.key,
              lastScanned: group.lastScanned,
              source: formatSource(group.source),
              defaultValue: group.defaultValue,
              list: group.list,
            };
            vm.allTranslations.push(translation);
          }
          if (group.translations)
            //Map translation object directly onto parent object
            angular.extend(translation, group.translations);

          if (
            !vm.listNames.find(function(x) {
              return x === group.list;
            })
          )
            vm.listNames.push(group.list);
        }
      } else {
        //Reloading all
        vm.allTranslations = data.map(function(group) {
          var translation = {
            key: group.key,
            lastScanned: group.lastScanned,
            source: formatSource(group.source),
            defaultValue: group.defaultValue,
            list: group.list,
          };

          if (group.translations)
            //Map translation object directly onto parent object
            angular.extend(translation, group.translations);

          if (
            !vm.listNames.find(function(x) {
              return x === group.list;
            })
          )
            vm.listNames.push(group.list);

          return translation;
        });
      }
      vm.listNames.sort();
      vm.filterTranslations();
      vm.loading = false;
    });
  };

  vm.reloadTranslations = function() {
    vm.allTranslations = [];
    vm.listNames = [];
    vm.getTranslations(vm.selectedLanguages);
  };

  vm.filterTranslations = function() {
    vm.translations = vm.allTranslations.filter(function(item) {
      if (vm.showNotScanned) {
        if (item.source || item.lastScanned) return false;
      }
      if (!!vm.fListName && item.list !== vm.fListName) return false;

      if (vm.fNotTranslated) {
        for (var i = 0; i < vm.selectedLanguages.length; i++) {
          var trans = item[vm.selectedLanguages[i]];
          if (!trans) return false;
          if (!(trans.value || (vm.fInherited && trans.inherited))) return true;
        }
        return false;
      }

      return true;
    });
    vm.translations = $filter(vm.fSimilar ? 'similar' : 'filter')(vm.translations, vm.search);

    vm.translations = $filter('orderBy')(vm.translations, vm.predicate, vm.reverse);
  };

  vm.removeTranslation = function(item) {
    translateSvc.removeList(item.key, 1).then(function() {
      var idx = vm.translations.findIndex(function(x) {
        return x.key === item.key;
      });
      if (idx >= 0) vm.translations.splice(idx, 1);

      idx = vm.allTranslations.findIndex(function(x) {
        return x.key === item.key;
      });
      if (idx >= 0) vm.allTranslations.splice(idx, 1);
    });
  };

  vm.save = function(item, lang, value) {
    translateSvc.saveList(lang, item.key, value, 1);
  };

  //Sorting
  vm.predicate = 'key';
  vm.reverse = false;
  vm.sort = function(predicate) {
    vm.reverse = vm.predicate === predicate ? !vm.reverse : false;
    vm.predicate = predicate;

    vm.translations = $filter('orderBy')(vm.translations, vm.predicate, vm.reverse);
  };
  //Load languages
  vm.allLanguages = translateSvc.languages;
  vm.filterLanguages();
  //Trigger initial load
  vm.reloadTranslations();
}
